import ActivityTypes from '@/constants/ActivityTypes';

export default function getMainActivity(theme) {
  if (!theme?.activities) {
    return null;
  }

  let video = null;
  let song = null;
  let game = null;
  let storyWithQuestion = null;
  let mainActivity = null;

  const mainActivityId = theme.mainActivity?.id;

  for (const activity of theme.activities) {
    if (activity.id == mainActivityId) {
      mainActivity = activity;
      break;
    } else {
      switch (activity.type) {
        case ActivityTypes.video:
          if (!video) {
            video = activity;
          }
          break;
        case ActivityTypes.song:
          if (!song) {
            song = activity;
          }
          break;
        case ActivityTypes.game:
          if (!game) {
            game = activity;
          }
          break;
        case ActivityTypes.storyWithQuestions:
          if (!storyWithQuestion) {
            storyWithQuestion = activity;
          }
          break;
      }
    }
  }

  return (
    mainActivity ||
    video ||
    song ||
    game ||
    storyWithQuestion ||
    theme.activities[0]
  );
}
